import { api } from './api'

export const fetchTransferRequest = (query) => api.get('/transfer-request', query)
